import { QueryClient } from "@tanstack/react-query";

import { is401Error } from "../lib/auth/authInterceptor";

/**
 * Creates a QueryClient configured for the workbench app.
 *
 * 401s are handled inside the BFF client wrapper ([[authInterceptor]]),
 * which triggers `handle401Response()` and re-throws. We must NEVER retry
 * a 401 here — retrying would dogpile the OAuth re-check.
 *
 * Other defaults are conservative and overridable per-hook.
 * @returns {QueryClient} A fresh QueryClient instance.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => !is401Error(error) && failureCount < 2,
        refetchOnWindowFocus: false,
        throwOnError: false,
      },
      mutations: {
        retry: false,
        throwOnError: false,
      },
    },
  });
}
